<template>
    <div id="main" class="is-flex">
        <div class="page">
            <div class="vertical-flow">
                <!-- TÍTULO -->
                <h1 class="title">{{ $t('config-mapa') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t('settings') }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{ $t('config-mapa') }}</a>
                        </li>
                    </ul>
                </nav>

                <div class="columns mt-0">
                    <div class="column">
                        <v-input
                            v-model="apikey"
                            class="lower"
                            title="chave-api-gmaps"
                            :placeholder="
                                disable
                                    ? 'edit-api-key-placeholder-enc'
                                    : 'edit-api-key-placeholder'
                            "
                            :maxlength="50"
                            :readonly="disable"
                            :disabled="loading"
                            :uppercase="false"
                        />
                    </div>
                    <div class="column is-narrow mt-4">
                        <button
                            class="delete-btn mt-2"
                            v-if="disable && permissao.update"
                            @click="editKey"
                        >
                            {{ $t('editar') }}
                        </button>
                        <button
                            class="save-btn mt-2"
                            v-if="
                                !disable &&
                                ((!isUpdate && permissao.create) || (isUpdate && permissao.update))
                            "
                            @click="promptSave"
                        >
                            {{ $t('salvar') }}
                        </button>
                        <button
                            class="delete-btn mt-2 ml-2"
                            v-if="!disable"
                            @click="testKeyIntoIframe"
                        >
                            {{ $t('testar-chave') }}
                        </button>
                    </div>
                </div>

                <div class="columns" v-if="!loading">
                    <div
                        class="column is-full is-flex is-flex-centered has-text-weight-bold is-default-text-color"
                    >
                        <span v-if="hasKey && !disable">{{ $t('msg-existing-changing-key') }}</span>
                        <span v-else-if="hasKey && !permissao.update">{{
                            $t('msg-existing-key-no-permission')
                        }}</span>
                        <span v-else-if="hasKey && permissao.update">{{
                            $t('msg-existing-key')
                        }}</span>
                        <span v-else>{{ $t('msg-nonexisting-key') }}</span>
                    </div>
                </div>

                <div class="iframe-area" v-if="show">
                    <iframe id="test-map-frame"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsuarioService from '@/services/UsuarioService';

export default {
    data() {
        return {
            service: new UsuarioService(this.$http, this.$router),
            apikey: '',
            disable: !!this.$store.state.user.gmapsApiKey,
            hasKey: !!this.$store.state.user.gmapsApiKey,
            loading: false,
            /* chave utilizada para criptografar a chave da api, em b64 */
            hk: 'UzBWMVMyMDA3UzBWMVMyMDE5UzBWMVMuIUAj',
            reload: Math.random(),
            show: false,
            testkey: '',
            isUpdate: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('admin', 'config-mapa', 'configuracao-mapas');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'config-mapa' },
            });
        }
    },
    methods: {
        editKey() {
            this.disable = false;
            this.isUpdate = true;
        },
        promptSave() {
            this.$root.confirm({
                message: this.$t('msg-confirm-save-key-cliente-n', {
                    n: this.$store.state.user.nomeClienteSovis,
                }),
                onConfirm: this.saveKey,
            });
        },
        saveKey() {
            let c = this.apikey.trim()
                ? this.$CryptoJS.AES.encrypt(this.apikey, atob(this.hk)).toString()
                : '';
            this.loading = true;

            this.service
                .saveGmapsKey(c)
                .then((r) => {
                    this.$buefy.dialog.alert({
                        message: this.$t('msg-success-save-key'),
                        type: 'is-primary',
                        onConfirm: () => {
                            location.reload();
                        },
                    });
                })
                .catch((e) => {
                    console.error('Erro ao salvar chave de API do google maps.', e);
                    this.$root.showMessage('error', 'msg-error-save-key');
                    this.loading = false;
                });
        },
        testKeyIntoIframe() {
            if (!this.show) {
                this.show = true;
            }

            this.$nextTick((_) => {
                document.querySelector('#test-map-frame').src = this.getTestPage(this.apikey);
            });
        },
        getTestPage(key) {
            let html = `<html>
<head>
    <meta name="viewport" content="initial-scale=1.0">
    <meta charset="utf-8">
    <style>
        #map {
            height: 100%;
        }
        html, body {
            height: 100%;
            margin: 0;
            padding: 0;
        }
        <\/style>
</head>
<body>
    <div id="map"></div>
    <script>
    function initMap() {
        new google.maps.Map(document.getElementById('map'), {
            center: {lat: -12.867, lng: -55.625},
            zoom: 4
        });
    }
    <\/script>
    <script src="https://maps.googleapis.com/maps/api/js?key=${key}&callback=initMap" async defer><\/script>
</body>
</html>`;

            return URL.createObjectURL(new Blob([html], { type: 'text/html' }));
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px 20px 20px;
    min-height: 100%;

    .page {
        h1 {
            margin-bottom: 40px;

            &.title {
                margin-right: 550px;
            }
        }

        button.delete-btn,
        button.save-btn {
            height: 36px;
            width: 100px;
            padding: 0;
        }

        .iframe-area {
            border: 1px solid $table-border;
            border-radius: 3px;
            height: 100%;
            min-height: 500px;

            iframe {
                width: 100%;
                min-height: 500px;
            }
        }
    }
}
</style>
